module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/lock-39d563b311863aa7adee27b3fb95d3f3.svg";